<template>
  <div id="tf-device">
    <div class="addcontainer card" ref="addcontainer" v-if="isOpen">
      <div class="card-head">
        <span>{{ $t("index.add") }}</span>
        <span class="close" @click="close">×</span>
      </div>
      <div class="card-content">
        <form>
          <div class="infoline">
            <div class="inputname">{{ $t("index.order") }}：</div>
            <input
              :placeholder="$t('index.orderin')"
              type="text"
              class="inputbox"
              v-model="newid"
            />
          </div>
          <div class="infoline">
            <div class="inputname"></div>
            <a-button
              type="primary"
              class="submitbtn"
              @click="submit"
              :loading="bindLoading"
              >{{ $t("index.bind") }}</a-button
            >
            <div class="warninfo">{{ warninfo }}</div>
          </div>
        </form>
      </div>
    </div>
    <div class="container">
      <!-- Container -->
      <div class="section-title text-center center zeropadding">
        <h2>{{ $t("index.myDevice") }}</h2>
        <div class="line">
          <hr />
        </div>
        <div class="clearfix"></div>
        <small
          ><em>{{ $t("index.devicein") }}</em></small
        >
      </div>
      <div class="space"></div>

      <div class="categories">
        <ul class="cat">
          <li class="pull-left">
            <h4>{{ $t("index.screen") }}:</h4>
          </li>
          <li class="pull-right">
            <ol class="type">
              <li>
                <a href="#" data-filter="*" class="active">{{ $t("index.all") }}</a>
              </li>
              <li>
                <a href="#" data-filter=".sheet">{{ $t("index.sheet") }}</a>
              </li>
              <li>
                <a href="#" data-filter=".tube">{{ $t("index.tube") }}</a>
              </li>
            </ol>
          </li>
        </ul>
        <div class="clearfix"></div>
      </div>

      <a-spin size="large" :spinning="spinning">
        <div
          id="lightbox"
          class="row"
          ref="lightbox"
          :style="{ minHeight: currentHeight }"
        >
          <div
            v-for="item in deviceItems"
            :key="item.equipmentid"
            class="col-sm-6 col-md-3 col-lg-3"
            :class="item.deviceType"
          >
            <div class="portfolio-item">
              <div class="hover-bg" @click="info(item)">
                <a href="#">
                  <div class="hover-text">
                    <h4>{{ item.name }}</h4>
                    <!-- <small>No.{{ item.equipmentid }}</small> -->
                    <div class="clearfix"></div>
                    <i class="fa fa-info-circle"></i>
                  </div>
                  <img
                    :src="imageSource(item.deviceType)"
                    class="img-responsive"
                    alt="..."
                  />
                </a>
                <p class="devicename">{{ item.name }}</p>
              </div>
            </div>
          </div>

          <div class="col-sm-6 col-md-3 col-lg-3 sheet tube">
            <div class="portfolio-item">
              <div class="hover-bg" @click="addDevice">
                <a href="#">
                  <div class="add-text">
                    <i class="fa fa-plus"></i>
                    <h4>{{ $t("index.add") }}</h4>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </a-spin>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";
import { message } from "ant-design-vue";

let container = ref(null);
const currentHeight = ref(0);
const startHeight = ref(0);
const lightbox = ref(null);
let newid = ref("");
let warninfo = ref("");
const addcontainer = ref(null);
let isOpen = ref(false);
const bindLoading = ref(false);
const user = ref();
const seriesList = ref([]);
const spinning = ref(false);
import { useI18n } from "vue-i18n";

const { t } = useI18n();

/* let { proxy } = getCurrentInstance(); */

let router = useRouter();

const deviceItems = ref([]);

user.value = JSON.parse(localStorage.getItem("user"));
localStorage.setItem("router", "device");

// 从localStorage中获取token信息
const token = localStorage.getItem("token");
console.log(token);

axios
  .post("api/Machine/GetDeviceSeries", {
    Path: "",
    Depth: "1",
  })
  .then((response) => {
    if (response.data.code != 200 && response.data.info != "暂无数据") {
      message.error(response.data.info);
    } else {
      if (response.data.ReturnData.length >= 1) {
        response.data.ReturnData.map((series) => {
          if (
            series.name == "M系列" ||
            series.name == "T系列" ||
            series.name == "K系列" ||
            series.name == "Q系列"
          ) {
            seriesList.value.push({
              name: series.name,
              id: series.id,
              type: "tube",
            });
          } else {
            seriesList.value.push({
              name: series.name,
              id: series.id,
              type: "sheet",
            });
          }
        });
      }
    }
  })
  .catch((error) => {
    console.error(error);
  })
  .finally(() => {
    getMyMachine();
  });

function imageSource(type) {
  return type == "sheet"
    ? require("@/assets/img/device/C.png")
    : require("@/assets/img/device/Q.png");
}

function info(device) {
  const params = device;
  if (device.infoStatus == 1) {
    router.push({
      name: "deviceInfo",
      params: {
        orderNumber: params.ordernumber,
        type: params.deviceType,
      },
    });
  } else {
    router.push({
      name: "deviceInfoWs",
      params: {
        orderNumber: params.ordernumber,
        type: params.deviceType,
      },
    });
  }
}

function addDevice() {
  isOpen.value = true;
  warninfo.value = "";
  return;
}

function close() {
  isOpen.value = false;
  warninfo.value = "";
  return;
}

function submit() {
  if (!newid.value) {
    warninfo.value = t("index.bindError");
    return;
  }
  bindLoading.value = true;
  axios
    .post("api/Machine/MachineBind", {
      OrderNumber: newid.value,
    })
    .then((response) => {
      if (response.data.code == 400 && response.data.info == "查无数据") {
        axios
          .post("api/Machine/GetBpmMachine", {
            OrderNumber: newid.value,
          })
          .then((response) => {
            if (response.data.info != 200 && response.data.info != "查无数据") {
              let pararm = response.data.ReturnData;
              pararm.OrderNumber = newid.value;
              pararm.Name = newid.value;
              axios.post("api/Machine/SaveMachineData", pararm).then((response) => {
                if (response.data.code != 200) {
                  message.error(response.data.info);
                } else {
                  axios
                    .post("api/Machine/MachineBind", {
                      OrderNumber: newid.value,
                    })
                    .then((response) => {
                      if (response.data.code != 200) {
                        message.error(response.data.info);
                      } else {
                        message.success(t("index.bindSuccess"));
                        isOpen.value = false;
                        location.reload();
                      }
                    });
                }
              });
            } else {
              message.error(response.data.info);
            }
          })
          .catch((error) => {
            console.error(error);
          });
      } else if (response.data.code != 200) {
        message.error(response.data.info);
      } else {
        message.success(t("index.bindSuccess"));
        isOpen.value = false;
        location.reload();
      }
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
      bindLoading.value = false;
    });
}

spinning.value = true;
function getMyMachine() {
  deviceItems.value = [];
  axios
    .post("api/Machine/GetMyMachine", {
      UserId: user.value.UserId,
    })
    .then((response) => {
      if (response.data.code != 200 || response.data.info == "数据查询为空！") {
        message.error(response.data.info);
      } else {
        if (response.data.ReturnData) {
          let seriesArr = [];
          response.data.ReturnData.map((data, index) => {
            deviceItems.value[index] = {
              equipmentid: data.equipmentid,
              name: data.ordernumber,
              infoStatus: data.communicationstatus,
              ordernumber: data.ordernumber,
              deviceType:
                data.seriesname == "M系列" ||
                data.seriesname == "T系列" ||
                data.seriesname == "K系列" ||
                data.seriesname == "Q系列"
                  ? (data.deviceType = "tube")
                  : (data.deviceType = "sheet"),
            };
            seriesArr.push(data.seriesname);
          });
          localStorage.setItem("series", seriesArr);
        }
      }
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
      lightbox.value = document.querySelector("#lightbox");
      if (lightbox.value) {
        const lightboxStyle = getComputedStyle(lightbox.value);
        startHeight.value = lightboxStyle.height; // 获取元素的高度并赋值给elementHeight
        currentHeight.value = startHeight.value;
      }

      container.value = jQuery("#lightbox"); // 设置 container 为 jQuery 选择的结果
      container.value.isotope({
        filter: "*",
        animationOptions: {
          duration: 750,
          easing: "linear",
          queue: false,
        },
      });

      $(".cat a").click(function () {
        $(".cat .active").removeClass("active");
        $(this).addClass("active");
        var selector = $(this).attr("data-filter");
        container.value.isotope({
          filter: selector,
          animationOptions: {
            duration: 750,
            easing: "linear",
            queue: false,
          },
        });
        return false;
      });
      spinning.value = false;
    });
}

onMounted(() => {});
</script>

<style scoped>
#tf-device {
  padding: 100px 0px;
  position: relative;
}

.section-title.center .line {
  border-top: 4px solid rgb(255, 70, 16);
}

.section-title.center hr {
  border-top: 4px solid rgb(255, 70, 16);
  opacity: 0.34;
  width: 40px;
  text-align: center;
  margin-top: 10px;
  position: relative;
  left: 17%;
}

.zeropadding {
  padding: 0px;
}

.hover-bg {
  background-color: #f3f3f4;
}

p {
  margin: 0px;
  text-align: center;
}

.devicename {
  font-size: 16px;
}

.add-text {
  width: 100%;
  height: 100%;
  border: 2px dashed #ccc !important;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.add-text i {
  margin-bottom: 10px;
  padding: 5px 5px 5px 6px !important;
}

.add-text h4 {
  color: rgb(255, 70, 16);
}

#tf-device i.fa {
  height: 30px;
  width: 30px;
  border: 1px solid rgb(255, 70, 16);
  font-size: 20px;
  padding: 5px;
  border-radius: 50%;
  color: rgb(255, 70, 16);
}

.addcontainer {
  position: fixed;
  width: 500px;
  top: 50vh;
  left: 50%;
  z-index: 999;
  transform: translate(-50%, -50%);
  /* 移动中心点位置 */
}

.card {
  box-sizing: border-box;
  border: none;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.16);
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.16);
  margin: 20px 0px;
  overflow: visible;
  transition: all 0.4s;
  font-size: 14px;
  background-color: white;
}

.card:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16), 0 1px 2px 1px rgba(0, 0, 0, 0.16);
}

.card:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16), 0 1px 2px 1px rgba(0, 0, 0, 0.16);
}

.card-head {
  width: 100%;
  align-items: center;
  color: #333;
  display: flex;
  justify-content: space-between;
  padding: 12px 15px;
}

.card-content {
  width: 100%;
  min-height: 50px;
  padding: 15px;
  display: flex;
}

.addcontainer form {
  width: 100%;
}

.inputbox {
  width: 65%;
  min-width: 0;
  padding: 4px 11px;
  font-size: 14px;
  line-height: 1.5715;
  background-color: white;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  transition: all 0.3s;
  display: inline-flex;
}

input {
  outline: none;
}

.inputbox:focus {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px #bae7ff;
  border-right-width: 1px !important;
  outline: 0;
}

.inputname {
  font-size: 14px;
  text-align: right;
  width: 25%;
}

.infoline {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  padding: 0;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  vertical-align: top;
  height: 32px;
}

.submitbtn {
  color: #fff;
  border-color: #1890ff;
  background: #1890ff;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
  line-height: 1.5715;
  position: relative;
  display: inline-block;
  font-weight: 400;
  white-space: nowrap;
  text-align: center;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  user-select: none;
  touch-action: manipulation;
  height: 32px;
  padding: 4px 15px;
  font-size: 14px;
  border-radius: 2px;
}

.submitbtn:hover {
  color: #fff;
  border-color: #40a9ff;
  background: #40a9ff;
}

.warninfo {
  margin-left: 20px;
  color: red;
}
</style>
